import { Link } from 'react-router';
import { Button } from '../../ui';
import { useAuth } from '../../auth/AuthProvider';
import { landingCopy } from './copy';
import { Hero } from './Hero';
import { FeatureHighlights } from './FeatureHighlights';
import { HowItWorks } from './HowItWorks';
import { UpcomingEventsPreview } from './UpcomingEventsPreview';
import { LandingFooter } from './LandingFooter';
import './landing.css';

/**
 * The signed-out landing page.
 *
 * A full-bleed, always-dark marketing surface rendered outside the app chrome. It keeps sign-up in
 * the upper-right corner (alongside sign-in), and gives an unauthenticated visitor a real sense of
 * the product: the pitch, the three pillars, how it works, and a preview of genuine upcoming events.
 *
 * @returns The landing element.
 */
export function LandingPage(): React.JSX.Element {
  const { signIn } = useAuth();

  return (
    <div className="gm-landing">
      <a className="gm-skip-link" href="#main">
        Skip to content
      </a>

      <header className="gm-landing__header">
        <Link to="/" className="gm-landing__brand">
          {landingCopy.brandLead}
          <span className="gm-landing__brand-mark">{landingCopy.brandTail}</span>
        </Link>

        <div className="gm-landing__actions">
          <Button onClick={() => signIn()}>{landingCopy.signIn}</Button>
          <Button variant="primary" onClick={() => signIn({ createAccount: true })}>
            {landingCopy.createAccount}
          </Button>
        </div>
      </header>

      <main id="main" className="gm-landing__main">
        <Hero onCreateAccount={() => signIn({ createAccount: true })} />
        <FeatureHighlights />
        <HowItWorks />
        <UpcomingEventsPreview />
      </main>

      <LandingFooter />
    </div>
  );
}
